<template>
  <div class="powerText2">
    <section class="row m-0 lxing">
      <img class="banner-img" :src="$t('centerDataImg')" alt="数据中心配图" />
    </section>
  </div>
</template>

<script>
export default {
  name: 'powerText',
  props: {
    msg: String,
  },
};
</script>

<style scoped lang="scss">
.powerText2 {
  padding: 1rem 0 3rem 0;
}
.lxing {
  width: 100%;
  overflow: hidden;
  border-radius: 10px;
}
.lxing ::v-deep .banner-img {
  display: block;
  width: 100%;
}
</style>
